import { useGetMentorship } from "@/lib/api/mentorships";
import { UserRole } from "@/lib/api/user.ts";
import { APP_ID } from "@/lib/constants.ts";
import { SendBirdProvider } from "@sendbird/uikit-react";
import {
  createFileRoute,
  Outlet,
  redirect,
  useParams,
} from "@tanstack/react-router";

export const Route = createFileRoute("/_admin_chat")({
  component: () => <AdminChatLayout />,
  beforeLoad: ({ context }) => {
    if (!context.stytchSession?.session_id || !context.user?.id) {
      throw redirect({ to: "/login" });
    }

    // Only allow admins to access this route
    if (
      context.user.role !== UserRole.ADMIN &&
      context.user.role !== UserRole.SUPERADMIN
    ) {
      throw redirect({ to: "/" });
    }
  },
});

function AdminChatLayout() {
  const { mentorshipId } = useParams({
    from: "/_admin_chat/chat/$mentorshipId",
  });
  const { data: mentorship, isPending } = useGetMentorship(mentorshipId);

  console.log(mentorship, mentorshipId);

  if (!mentorship || isPending) return null;

  return (
    <SendBirdProvider
      appId={APP_ID}
      userId={mentorship.mentor?.id}
      accessToken={mentorship.mentor?.sendbird_access_token}
    >
      <Outlet />
    </SendBirdProvider>
  );
}
